import { ListItemText, Stack, Tooltip, type StackProps } from "@mui/material";

interface IDetailItem extends StackProps {
  primary: string;
  secondary: string;
}

export const DetailItem: React.FC<IDetailItem> = (props) => {
  const { primary, secondary, ...stackProps } = props;
  return (
    <Stack {...stackProps}>
      <span>
        <Tooltip title={secondary} arrow>
          <ListItemText
            primary={primary}
            secondary={secondary}
            slotProps={{
              primary: {
                variant: "body1",

                sx: {
                  fontWeight: "fontWeightMedium",
                },
                noWrap: true,
              },
              secondary: {
                noWrap: true,
                variant: "body1",
              },
            }}
          />
        </Tooltip>
      </span>
    </Stack>
  );
};
